import { IconContent } from '@icons';

export const padlockToggleClosed: IconContent = {
    sm: '<path fill-rule="evenodd" clip-rule="evenodd" d="M5.99988 1C4.61917 1 3.49988 2.11929 3.49988 3.5V7H8.49988V3.5C8.49988 2.11929 7.38059 1 5.99988 1ZM2.49988 3.5V7H0.999878H-0.00012207V8V15V16H0.999878H10.9999H11.9999V15V8V7H10.9999H9.49988V3.5C9.49988 1.567 7.93287 0 5.99988 0C4.06688 0 2.49988 1.567 2.49988 3.5ZM0.999878 8H2.49988H3.49988H10.9999V15H0.999878V8ZM6.49988 12.9143V10H5.49988V12.9143H6.49988Z" fill-opacity="0.64"/>',
};
